import React, { Component } from 'react';
import axios from 'axios'
import { Form, Segment, Button, Card, Label } from 'semantic-ui-react'
import { firebaseAuth, logComponentLoad, serverIp } from '../../../../config/constants'
import { checkAdminEmail, getLargeProjectItem } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import LargeProjectOrderEntry_options from './LargeProjectOrderEntry_options'
import ViewProject_header from './ViewProject_header'
import { Link } from 'react-router-dom';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });


class EditLargeProjectItem_option_value extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            algoliaUser: '',
            option: '',
            measurement: '',
            option_selection: '',
            largeProjectItem_option_value: ''
        }
    }

    componentDidMount() {
        console.log("edIpc1 ++++++++++ searchNow componentDidMount");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("edIpc12 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("edIpc12 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("edIpc13 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }



    setAdminResult = (returnObject) => {
        // console.log("edIpc12 ++++++ addx294 setAdminResult");
        // console.log("edIpc13 returnObject:" + JSON.stringify(returnObject, null, 3));

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        logComponentLoad(returnObject, "EditLargeProjectItem_option_value");

        if (returnObject.algoliaUser.perms && returnObject.algoliaUser.perms.includes("largeProjectOrderEntry")) {

            if (this.props.match.params.largeProjectItem_option_id) {

                this.getLargeProjectItem_option();

            } else {
                alert("edIpc13 No inHouseCostId Sent")

            }
        } else {
            alert("loading error ex4")
        }
    }


    setShirtTypeDropDown = (shirtTypes) => {
        console.log("edIpc13 +++++++:setShirtTypeDropDown");
        //console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            loading: false,
            shirtTypeChoices: shirtTypes
        })

    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    getShirtTypeOption = (objects) => {
        console.log("epx15 ++++++++:getShirtTypeOption");
        //  console.log("epx16 hits:" + JSON.stringify(objects, null, 3));

        this.setState({
            loading: false
        })

        if (objects.length > 0) {
            console.log("epx17 object is there...");
            console.log("epx18 OPTIONS :" + JSON.stringify(objects[0].options, null, 3));

            console.log("epx161 optionName:" + this.state.option.categoryOption);

            //CHECK IF EXISTS
            let foundIndex = objects[0].options.findIndex(x => x.option_name == this.state.option.categoryOption);
            console.log("epx19 foundIndex:" + foundIndex);

            if (foundIndex != -1) {
                console.log("epx20 foundIndex != -1, item is there:" + this.state.option.categoryOption);

                console.log("epx21 option_selection :" + JSON.stringify(objects[0].options[foundIndex], null, 3));

                this.setState({
                    option_selection: objects[0].options[foundIndex]
                })
            } else {
                console.log("item option not found");
                alert("item option not found");
            }

            // this.setState({
            //     large_project_object: objects[0],
            //     checkOptionsArray: objects[0].options
            // })

            // this.setCheckOptionsArray(objects[0].options)
        }
    }

    getLargeProjectItem_option = () => {
        console.log("epx1 ++++++++:getLargeProjectItem_option");

        this.setState({ loading: true })

        axios.post(serverIp + "large_project_items/getLargeProjectItem_option", {
            apiKey: "getLargeProjectItem_option",
            largeProjectItem_option_id: this.props.match.params.largeProjectItem_option_id,
            enteredBy: this.state.user.email
        })
            .then((response) => {

                this.setState({ loading: false })
                console.log("epx11 :" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {

                    //CHECK FOR OPTION
                    if (response.data.option) {
                        console.log("epx12 response.data.option:" + JSON.stringify(response.data.option, null, 3));
                        console.log("epx13 shirtType:" + response.data.option.largeProjectItem.shirtType.shirtType);

                        if (response.data.option.optionType == 'measurement') {
                            console.log("epx131 optionType == measurement");
                            this.setState({
                                isMeasurement: true,
                                option: response.data.option
                            })


                        } else if (response.data.option.optionType == 'option') {
                            console.log("epx131 optionType == option");
                            //1. GET MAIN CARD OBJECTS FROM ALGOLIA
                            getLargeProjectItem("large_project_objects", response.data.option.largeProjectItem.shirtType.shirtType, this.getShirtTypeOption);
                            this.setState({
                                option: response.data.option
                            })

                        } else {

                        }


                    } else {
                        console.log("edIpc143 inHouseCost does not exists");

                    }

                } else {
                    alert(response.data.message)
                }



            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState['largeProjectItem_option_value'] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    resetFeilds = () => {
        this.setState({
            description: '',
            qty: '',
            cost: '',
            shirtTypeId: ''
        })
    }

    updateLargeProjectItemValue = () => {
        console.log("++++++++:sendCustomer");
        console.log("edIpc16 largeProjectItem_option_value:" + this.state.largeProjectItem_option_value)
        console.log("edIpc164 enteredBy:" + this.state.user.email)

        if (this.state.largeProjectItem_option_value == '') {
            alert("No largeProjectItem_option_value Entered")
        } else {
            console.log("sending data..udpateInHouseCost");

            this.setState({ loading: true });

            axios.post(serverIp + "large_project_items/updateLargeProjectItemValue", {
                apiKey: "updateLargeProjectItemValue",
                largeProjectItem_option_id: this.props.match.params.largeProjectItem_option_id,
                largeProjectItem_option_value: this.state.largeProjectItem_option_value,
                enteredBy: this.state.user.email
            })
                .then((response) => {

                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. option modified");

                        //this.resetFeilds();
                        this.setState({
                            loading: false,
                            // showProjectCosts: true,
                            // projectCosts: response.data.projectCosts
                        })


                        alert(response.data.message);
                        this.getLargeProjectItem_option();
                    } else {
                        console.log("FAILED");
                        this.setState({
                            loading: false,

                        })
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    handleTextInputChange = (e) => {
        console.log("mx1 >>>>: handleTextInputChange ");
        console.log("mx33 e.target.type:" + e.target.type);
        console.log("mx32 e.target.name:" + e.target.name);
        console.log("mx34 e.target.value:" + e.target.value);

        let newState = {};
        newState[e.target.name] = e.target.value;
        this.setState(newState);

        //this.props.handleTextInputChange(e);

    }

    render() {


        const optionsDropdown = this.state.option_selection != ''
            ? <div>
                <Form size='large' onSubmit={this.updateLargeProjectItemValue}>
                    <Segment stacked>

                        <label>Select Items</label>

                        <LargeProjectOrderEntry_options
                            option={this.state.option_selection}
                            handleLargeProjectEntryDropDownChanges={this.handleDropDownChanges} />

                        <Button color='brown' fluid>UPDATE </Button>
                    </Segment>
                </Form>


            </div>
            : ''

        const optionDetails = this.state.option != ''
            ? <Card>
                <Card.Content>
                    <Card.Header>#{this.state.option.idlargeProjectItemOptions} {this.state.option.largeProjectItem.shirtType.shirtType.replace('large_project_', "")} - {this.state.option.largeProjectItem.itemName}</Card.Header>
                    <Card.Header>Name: {this.state.option.largeProjectItem.itemName}</Card.Header>
                    <Card.Header>Option: {this.state.option.categoryOption} </Card.Header>
                    <Card.Header>Current Value: {this.state.option.valueOption} </Card.Header>

                </Card.Content>
            </Card>
            : ''

        const measurementFeild = this.state.option != '' && this.state.isMeasurement
            ? <div>
                <Form size='large' onSubmit={this.updateLargeProjectItemValue}>
                    <Segment stacked>
                        <Label pointing='below' color='blue'>{this.state.option.categoryOption}</Label>
                        <Form.Input
                            fluid
                            icon='person'
                            iconPosition='left'
                            placeholder={this.state.option.valueOption}
                            type='number'
                            name='largeProjectItem_option_value'
                            onChange={this.handleTextInputChange}
                        />
                        <Button color='brown' fluid>UPDATE </Button>
                    </Segment>
                </Form>

            </div>
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("editProjectCosts")
            ? <div>
                <ViewProject_header projectId={this.props.match.params.projectId} user={this.state.user} />
                {optionDetails}
                {optionsDropdown}
                {measurementFeild} 
                <Button fluid color='green'>
                    <Link to={'/dashboard/viewLargeProjectItems/' + this.props.match.params.projectId}>PROJECT HOME</Link>
                </Button>
            </div>
            : <h4>loading error a75</h4>

        //const projectCosts = this.state.showProjectCosts && this.state.projectId && !this.props.projectId
        // const projectCosts = this.props.projectId
        //     ? <ViewLargeProjectCosts projectId={this.props.projectId} projectCosts={this.state.projectCosts} />
        //     : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>

                {wholeUI}


            </div>
        );
    }
}

export default EditLargeProjectItem_option_value;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/EditLargeProjectItem_option_value.js